import React, { useContext } from "react";
import CertificationContext from "module/certification/context/CertificationContext";
import { CertificationInterface } from "module/certification/types";
import CertificationAssigneeLabelField from "module/certification/enrichedComponent/assigneeField/CertificationAssigneeLabelField";

const CertificationAssigneeContainer: React.FC = () => {
  const { entity } = useContext(CertificationContext);
  const { assigneeId } = entity as CertificationInterface;

  return <CertificationAssigneeLabelField {...{ assigneeId }} />;
};

export default React.memo(CertificationAssigneeContainer);
